// removed by extract-text-webpack-plugin
module.exports = {"converterWrapper":"converterWrapper__1gV7k","conversion-holder":"conversion-holder__3nTaw","conversion-holderFrom":"conversion-holderFrom__1X01l","conversion-holderTo":"conversion-holderTo__2PT71","conversion-small":"conversion-small__1WXmv","bg":"bg__2nZn2","afterPointShade":"afterPointShade__3m3PU","error":"error__1_8FJ"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Conversionfold/Converter/converter.scss
// module id = 727
// module chunks = 68